import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Tag } from "@parkschannel/ui";
import classNames from "classnames";
import { useTruncatedList } from "./hooks";
export const TruncatedTagsList = (param)=>{
    let { tags , color ="gray" , prefixTag , suffixTag , className  } = param;
    const listRef = useRef(null);
    const { hiddenElements  } = useTruncatedList(listRef);
    return /*#__PURE__*/ _jsxs("ul", {
        ref: listRef,
        className: classNames("max-w-full w-full flex gap-1 overflow-hidden", className),
        children: [
            prefixTag && /*#__PURE__*/ _jsx("li", {
                className: "inline-block",
                children: prefixTag
            }),
            tags.map((tag)=>/*#__PURE__*/ _jsx("li", {
                    style: {
                        position: "absolute",
                        opacity: 0
                    },
                    className: "inline-block",
                    children: /*#__PURE__*/ _jsx(Tag, {
                        value: tag.name,
                        size: "sm",
                        color: color
                    })
                }, tag.id)),
            suffixTag && /*#__PURE__*/ _jsx("li", {
                className: "inline-block",
                children: suffixTag
            }),
            hiddenElements > 0 && /*#__PURE__*/ _jsx(Tag, {
                id: "list-counter",
                value: "+ ".concat(hiddenElements, " more"),
                color: "gray"
            })
        ]
    });
};
